import { useLocation } from 'react-router-dom';

/**
 * Custom hook to determine whether the context is 'site', 'asset', or 'schedule' based on the URL pathname.
 * @returns {'site' | 'asset' | 'schedule'} The context type.
 */

export const useContextType = (): 'site' | 'asset' | 'schedule' => {

  const { pathname } = useLocation();

  let module: 'site' | 'asset' | 'schedule' = 'asset'; 

  if (pathname.includes('/schedule/')) {
    module = 'schedule';
  } else if (pathname.includes('/assets/')) {
    module = 'asset';
  } else if (pathname.includes('/sites/')) {
    module = 'site';
  }

  return module;

};